if (!customElements.get("collection-banner-slider")) {
  customElements.define(
    "collection-banner-slider",
    class CollectionBannerSlider extends HTMLElement {
      constructor() {
        super();
        this.initSwiper();
      }

      initSwiper() {
        if (this.swiper) this.swiper.destroy();
        const sliderIdentifier = this.dataset.id;
        let perPage = this.dataset.row;
        let autoplay = this.dataset.autoplay === "true";
        let autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10);
        this.swiper = new Swiper(`[data-id="${sliderIdentifier}"]`, {
          slidesPerView: 1,
          loop: true,
          autoplay: autoplay
            ? {
                delay: autoplaySpeed * 1000,
                disableOnInteraction: false,
              }
            : false,
          breakpoints: {
            1024: {
              slidesPerView: perPage,
            },
          },
          pagination: {
            el: `.swiper-pagination-${sliderIdentifier}`,
            type: "bullets",
            clickable: true,
          },
        });
      }
    }
  );
}
